import {
  Component,
  OnInit
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";


export interface ImportFromFileModel {
  title: string;
}

@Component({
  selector: 'app-importfromfile',
  templateUrl: './importfromfile.component.html',
  styleUrls: ['./importfromfile.component.css']
})
export class ImportfromfileComponent extends DialogComponent<ImportFromFileModel, boolean> implements OnInit, ImportFromFileModel {
  title: string;
  result: any = { result: false, RtnItem: {} };
  fromfile: any;
  fileModel: any = {
    Barcode: 1, Qty: 2
  };
  stockView: any;
  fileCol: any;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }


  ngOnInit() {
    this.fileModel = {
      Barcode: 1, Qty: 2
    }
  }
  ok() {
    this.stockView = [];
    if (this.fromfile.length != 0) {
      var q = (Number(this.fileModel.Qty) - 1);
      var b = (Number(this.fileModel.Barcode) - 1);
      for (let i of this.fromfile) {
        if (i[q] && i[b]) {
          if (i[q] != "" && i[b] != "") {
            this.stockView.push({ actualqty: Number(i[q]), Barcode: i[b], batchno: "", branchid: 1, costprice: 0, difference: 0, expirydate: new Date(), ID: 1, ItemName: "", StockAdjestmentID: 0, systemqty: 0, total: 0, Unit: "", StockExpiryDetails: [] })
          }
        }
      }
    } else {
      alert("Selected file is Empty")
    }
    this.result.RtnItem.data = this.stockView;
    this.result.result = true;
    this.close();
  }
  fileUpload(event) {
    var reader = new FileReader();
    reader.readAsText(event.srcElement.files[0]);
    var me = this;
    var result = [];
    reader.onload = function () {
      var lines = reader.result.split("\n");
      var headers;
      headers = lines[0].split(",");
      var cont = 0;
      for (var i = 0; i < lines.length; i++) {
        var obj = lines[i].split(",");
        result.push(obj);
      }
    }
    this.fromfile = result;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/importfromfile/importfromfile.component.ts